import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { faCog, faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RoleAction, RolePermissionSubject } from '@wilson/interfaces';
import { AuthorizationModule } from '@wilson/authorization';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { AbilityServiceSignal } from '@casl/angular';

@Component({
  selector: 'wilson-assign-all-shifts-with-activities-button-view',
  imports: [
    TranslateModule,
    NzButtonModule,
    NzSpinModule,
    NzModalModule,
    NzDropDownModule,
    FontAwesomeModule,
    AuthorizationModule,
    NzTooltipModule,
  ],
  templateUrl: './assign-all-shifts-button-view.component.html',
  styleUrl: './assign-all-shifts-button-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignAllShiftsButtonViewComponent {
  @Input()
  isLoading!: boolean;

  @Output()
  createAssignmentJob = new EventEmitter();

  @Output()
  openOptimizerSettingsDrawer = new EventEmitter();

  protected faSparkles = faSparkles;
  protected faCog = faCog;
  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;
}
